import { render } from "./payin.vue?vue&type=template&id=4901d5fa&scoped=true&ts=true"
import script from "./payin.vue?vue&type=script&lang=ts"
export * from "./payin.vue?vue&type=script&lang=ts"

import "./payin.vue?vue&type=style&index=0&id=4901d5fa&lang=less&scoped=true"
import "./payin.vue?vue&type=style&index=1&id=4901d5fa&lang=less&scoped=true"
import "./payin.vue?vue&type=style&index=2&id=4901d5fa&lang=less"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4901d5fa"]])

export default __exports__